import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useStore } from "@/context/StoreContext";
import { objectPosition } from "@/lib/focal";
import ProductCard from "@/components/store/ProductCard";

export default function Ambassador() {
  const [data, setData] = useState(null);
  const { config } = useStore();

  useEffect(() => {
    document.title = "Meet Pia — The Face of Siyaara";
    api.get("/ambassador").then((r) => setData(r.data)).catch(() => setData({}));
  }, []);

  if (!data) return <div className="container-x py-20 text-center text-ink-2 font-mono text-sm">LOADING…</div>;
  const name = data.name || "Pia";

  return (
    <div data-testid="ambassador-page">
      <section className="relative h-[70vh] min-h-[440px] overflow-hidden bg-brand">
        {data.hero_image ? (
          <img src={data.hero_image} alt={name} className="absolute inset-0 h-full w-full object-cover" style={{ objectPosition: objectPosition(data.hero_image, config) }} data-testid="ambassador-hero-image" />
        ) : data.hero_video ? (
          <video className="absolute inset-0 h-full w-full object-cover" src={data.hero_video}
            poster={data.poster || undefined} autoPlay muted loop playsInline preload="metadata" data-testid="ambassador-video" />
        ) : data.gallery?.[0] ? (
          <img src={data.gallery[0]} alt={name} className="absolute inset-0 h-full w-full object-cover" style={{ objectPosition: objectPosition(data.gallery[0], config) }} />
        ) : null}
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent" />
        <div className="absolute bottom-0 inset-x-0 container-x pb-12">
          <p className="eyebrow !text-gold">THE FACE OF SIYAARA</p>
          <h1 className="font-heading text-5xl sm:text-6xl font-semibold text-white mt-2" data-testid="ambassador-name">{name}</h1>
          {data.bio && <p className="text-white/85 text-sm sm:text-base mt-3 max-w-xl leading-relaxed" data-testid="ambassador-bio">{data.bio}</p>}
        </div>
      </section>

      {data.gallery?.length > 0 && (
        <section className="container-x mt-14" data-testid="ambassador-gallery">
          <p className="eyebrow !text-gold">THE CAMPAIGN</p>
          <h2 className="font-heading text-3xl font-semibold mt-1">Warm neutrals, real light</h2>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
            {data.gallery.map((g, i) => (
              <div key={i} className="rounded-xl overflow-hidden border border-brand/10 aspect-[3/4] bg-white">
                <img src={g} alt={`${name} campaign ${i + 1}`} loading="lazy" style={{ objectPosition: objectPosition(g, config) }} className="h-full w-full object-cover hover:scale-105 transition-transform duration-700" />
              </div>
            ))}
          </div>
        </section>
      )}

      {data.products?.length > 0 && (
        <section className="container-x mt-14" data-testid="ambassador-products">
          <p className="eyebrow !text-gold">SHOP THE LOOK</p>
          <h2 className="font-heading text-3xl font-semibold mt-1">As worn by {name}</h2>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
            {data.products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
          </div>
        </section>
      )}

      {(data.credit || data.media_credit_line || config?.media_credit_line) && (
        <p className="container-x mt-10 text-xs text-ink-2" data-testid="ambassador-credit">
          {data.credit || data.media_credit_line || config?.media_credit_line}
        </p>
      )}
      <div className="h-14" />
    </div>
  );
}
